import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const MostUsedEventsAndAttributesDataTable = lazy(() =>
  import("@scenes/MostUsedEventsAndAttributesDataTable").then((module) => ({
    default: module.MostUsedEventsAndAttributesDataTable,
  }))
);

export const dataPointsNRO: NavigationRoutingObject = {
  section: "settings",
  Component: MostUsedEventsAndAttributesDataTable,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("billing-most-used-events", "Most Used Events and Attributes by App (Estimated)"),
  pageNameForTracking: () => "Most Used Events and Attributes by App (Estimated)",
  getDeveloperNavigationAllowed: ({ hasPermission }) => {
    return hasPermission("appGroup", {
      permission: "viewBilling",
    });
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("data-points-alt-keyword-1", "Most Used Events"),
        t("data-points-alt-keyword-2", "Most Used Attributes"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
